import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {PERMISSIONS} from '../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../_helpers/UserPermissionSingleton';

export default class PdfLink extends Component {
    static get propTypes() {
        return {
            collectionId: PropTypes.string.isRequired,
            getPdfsByCollectionId: PropTypes.func.isRequired,
            pdfLinks: PropTypes.object.isRequired
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            pdfLinksPolledCount: 0
        };
        this.pdfLinksTimeout = null;
    }

    componentWillMount() {
        this.props.getPdfsByCollectionId(this.props.collectionId);
    }

    componentWillReceiveProps(nextProps){
        if (this.props.pdfLinks !== nextProps.pdfLinks) {
            const isEpsUploadPending = nextProps.pdfLinks.printContents.find((pdfLink) => pdfLink.isEPSUploaded === false);
            if (isEpsUploadPending && this.state.pdfLinksPolledCount < 50 && !nextProps.pdfLinks.isFetching) {
                this.pollForPdfLinks();
            } else {
                clearTimeout(this.pdfLinksTimeout);
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.pdfLinksTimeout);
    }

    render() {
        const {pdfLinks } = this.props;
        return (
            <div className="book-details-pdf-links-wrapper">
                {pdfLinks.printContents && pdfLinks.printContents.map(
                    pdfDetail => (
                        <div>
                            {(!UserPermissionSingleton.hasPermission(PERMISSIONS.hide_only_pdflinks) || (pdfDetail.printPageType !== 'Content' && pdfDetail.printPageType !== 'Full Book Content')) &&  <div key={pdfDetail.id} className="book-details-pdf-link">
                                <div className="link-content">
                                    <div>
                                        <img src="/digitaladmin/images/pdf.png" alt="PDF Icon" />
                                    </div>
                                    {(pdfDetail.isEPSUploaded) ?
                                        <div>
                                            <a href={pdfDetail.contentUrl} target="_blank">{pdfDetail.printPageType}</a>
                                        </div>
                                        :
                                        <div>
                                            <span>{pdfDetail.printPageType}</span>
                                            <span>(Pending)</span>
                                        </div>
                                    }
                                    {(pdfDetail.contentSource === 'Custom') && <i className="fa fa-flag-o"/> }
                                </div>
                            </div>}
                        </div>
                    )
                )}
            </div>
        );
    }


    pollForPdfLinks() {
        this.setState(prevState => {
            return { pdfLinksPolledCount: prevState.pdfLinksPolledCount + 1 };
        });

        this.pdfLinksTimeout = setTimeout(() => {
            this.props.getPdfsByCollectionId(this.props.collectionId);
        }, 10000);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerComponents/PdfLink.js